export const SET_ACTIVE_DEPARTURE_CROSSING =
  'activeCrossings/SET_ACTIVE_DEPARTURE_CROSSING'
export const SET_ACTIVE_RETURN_CROSSING =
  'activeCrossings/SET_ACTIVE_RETURN_CROSSING'
export const RESET_ACTIVE_CROSSINGS = 'activeCrossings/RESET_ACTIVE_CROSSINGS'
export const RESET_RETURN_CROSSINGS = 'activeCrossings/RESET_RETURN_CROSSINGS'
